const lang = {};

const poeditorFile = require.context(
    // 컴포넌트들이 있는 폴더
    '@/common/language/',
    // 하위 폴더까지 포함할 지 여부
    false,
    // 기본 컴포넌트를 찾는데 사용할 정규표현식
    /\.json$/
);

poeditorFile.keys().forEach(fileName => {
    if (fileName === './index.js') return;
    lang[fileName.split('/').pop().replace(/\.\w+$/, '')] = poeditorFile(fileName).map(x => {
        return {term: x.term, definition: x.definition}
    });
});


export default lang